import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { del } from 'utils/http'

export const useCustomerEnrichApiKeyDelete = () => {
  const customerId = useCustomerId()
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  const deleteApiKey = () => del(`/management/customers/${customerId}/enrich_api`)

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: deleteApiKey,
    onSuccess: async () => {
      await queryClient.resetQueries({ queryKey: ['customer', customerId, 'enrich_api_key'] })
      await queryClient.resetQueries({ queryKey: ['customer', customerId, 'enrich_api_quota'] })
      addNotification('Enrich API key has been removed')
    },
    onError: () => {
      addNotification('Error while removing Enrich API key', 'error')
    },
  })

  return {
    deleteEnrichApiKey: mutateAsync,
    ...rest,
  }
}
